import { MessageType } from "../types";

const MESSAGE_PLACEHOLDERS: Record<MessageType, string> = {
  system: "",
  user: "",
  assistant: "",
  function: '{"location": "Brooklyn, NY", "weather": "Sunny"}',
  tool: "",
  placeholder: "Name of the placeholder variable...",
  developer: "",
};

const MESSAGE_DETAILS: Record<MessageType, string> = {
  system: "",
  user: "",
  assistant: "",
  function: "",
  tool: "",
  placeholder:
    "Dynamically injects message objects at runtime. Commonly used for conversation history. Must be an array of messages with role and content properties.",
  developer: "",
};

export { MESSAGE_PLACEHOLDERS, MESSAGE_DETAILS };
